export default "__VITE_PUBLIC_ASSET__1f39e804__"